import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9v893wm2yy: FaireBrandEntity = {
  token: "b_9v893wm2yy",
  type: "brand",
  name: "Golden Parrot",
  avatarUrl:
    "https://cdn.faire.com/fastly/550d4c33807e978996d2f9c2c14bc8c0c4a1a3a0282a570f41a454e5cff5e4d8.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e215875d92603bebc93ba806c0f83cb4c052842792f3c18d3f59db6a7468f92f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/550d4c33807e978996d2f9c2c14bc8c0c4a1a3a0282a570f41a454e5cff5e4d8.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e215875d92603bebc93ba806c0f83cb4c052842792f3c18d3f59db6a7468f92f.jpeg",
  location: "Fort Wayne , IN, USA",
  minimumOrderDollars: 99,
  rating: 4.9,
  reviewCount: 318,
  isTopShop: true,
  isInsider: true,
  description:
    "Hi, I’m Wendy Ellis, founder of Golden Parrot.\n\nWith over 10 years in the wholesale and boutique business, I created Golden Parrot to share unique, on-trend products and to build real relationships with the retailers I work with. I’ve always loved helping stores find pieces that feel fresh, special, and easy to sell.\n\nThe heart of my business is creativity and connection. I especially love working directly with customers to design custom pieces and bring new ideas to life. That hands-on, collaborative process is my favorite part of what I do, and it’s what makes Golden Parrot different.\n\nI started this business to make wholesale feel more personal, inspiring, and fun, with great products, thoughtful service, and a genuine love for helping boutiques stand out.",
  meta: {
    source: "api",
    importedAt: "2026-07-17T18:40:34.849Z",
    importedBy: "entity-db-cli",
  },
};
